module.exports = __webpack_public_path__ + "img/tractor_slurry.4e7cd118.png";